export default __webpack_public_path__ + "static/media/icon_private.1455e94f.svg";